/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromFirebaseRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromFirebaseRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'] == null ? undefined : json['GameSystemName'],
        'Token': json['Token'],
        'MarketingEnabled': json['MarketingEnabled'] == null ? undefined : json['MarketingEnabled'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'Token': value['Token'],
        'MarketingEnabled': value['MarketingEnabled'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromFirebaseRequest.js.map